export default __webpack_public_path__ + "static/defilytica_simple-0043c91eb0fa917843559c4a217f9a8b.png";